<template>
  <h1 class="text-4xl font-extrabold tracking-tighter text-center lg:text-5xl">
    <slot></slot>
  </h1>
</template>
